function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "chevron one",
  d: "M27.0815 6.01041L20.0104 13.0815M27.0815 8.13173L20.0104 1.06066",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "chevron two",
  d: "M20.0815 6.01041L13.0104 13.0815M20.0815 8.13173L13.0104 1.06066",
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "chevron three",
  d: "M13.0815 6.01041L6.01041 13.0815M13.0815 8.13173L6.01041 1.06066",
  strokeWidth: 3
});

function SvgChevrons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 15,
    viewBox: "0 0 29 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrons);
export default __webpack_public_path__ + "static/media/chevrons.01bcd699.svg";
export { ForwardRef as ReactComponent };